interface DescriptionProps {
  children: React.ReactNode;
}

const Description = ({ children }: DescriptionProps) => {
  return (
    <p className="leading-[28px] text-[16px] !font-[B-Nazanin]">{children}</p>
  );
};

export default Description;
